import React from 'react';
import { DateValidationError, LocalizationProvider, PickerChangeHandlerContext } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/icon-calendar.svg';
import colors from '../../../assets/styles/colors';
import commons from '../../../assets/styles/commons';
import { styled } from '@mui/system';
import FormHelperText from '@material-ui/core/FormHelperText';
import { PaddingsMargins } from '../../../assets/styles/interface';
import { Moment } from 'moment';

interface Props extends PaddingsMargins {
  label: string;
  placeholder: string;
  value: Moment | null;
  onChange: (date: Moment | null) => void;
  defaultValue?: Moment | null;
  errorMessage?: string;
  children?: string;
}

const DatePickerStyle = styled(DatePicker)(({ theme }) => ({
  '&.MuiInputBase-root': {
    position: 'relative',
    backgroundColor: colors.secondary.softBlue,
    border: '1px solid',
    borderColor: colors.primary.orange,
    flex: 1,
    width: 'auto',
    fontFamily: commons.fontFamily,
  },
  '&.MuiTextField-root': {
    backgroundColor: colors.secondary.softBlue,
  },
  '& .MuiInputBase-root-MuiOutlinedInput-root': {
    backgroundColor: colors.secondary.softBlue,
  },
}));

const Label = styled('div')({
  color: colors.primary.orange,
  fontFamily: commons.fontFamily,
  fontSize: '13px',
});

const DatePickerCustom: React.FC<Props> = ({
  label,
  errorMessage,
  placeholder,
  value,
  ...props
}) => {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DemoItem label={<Label>{label}</Label>}>
          <DatePickerStyle
            slots={{
              openPickerIcon: CalendarIcon,
            }}
            onChange={(newValue: unknown, context: PickerChangeHandlerContext<DateValidationError>) => props.onChange(newValue as Moment | null)}
            value={value}
            format="DD/MM/YYYY"
            slotProps={{ textField: { size: 'small' } }}
            showDaysOutsideCurrentMonth
            sx={{
              marginRight: props.mr,
              marginLeft: props.ml,
              marginTop: props.mt,
              marginBottom: props.mb,
            }}
          />
          {errorMessage && (
            <FormHelperText style={{ color: colors.error.intenseRed }}>
              {errorMessage}
            </FormHelperText>
          )}
        </DemoItem>
      </LocalizationProvider>
    </>
  );
};

export default DatePickerCustom;
